export default __webpack_public_path__ + "static/media/coingecko.13738de2.png";